<template>
  <DefaultLayout :footer-size="footerSize" wide>
    <slot />
  </DefaultLayout>
</template>

<script setup lang="ts">
import DefaultLayout from './DefaultLayout.vue'

defineProps<{
  hiddenFooter?: boolean
  footerSize?: 'large' | 'small'
}>()
</script>
